module.exports = __webpack_public_path__ + "static/img/walking-man-red.aa28084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-red.svg
// module id = G0VA
// module chunks = 74